var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredWire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0014 13.6351C17.1496 13.6351 15.6484 14.8361 15.6484 16.3175C15.6484 17.7989 16.7661 18.9998 19.0014 18.9998C21.2367 18.9998 22.3543 20.2008 22.3543 21.6822C22.3543 23.1636 20.8532 24.3645 19.0014 24.3645M19.0014 13.6351C20.2424 13.6351 21.326 14.1745 21.9057 14.9763M19.0014 13.6351V12.2939M19.0014 24.3645L19.0014 25.7057M19.0014 24.3645C17.7603 24.3645 16.6768 23.8251 16.097 23.0234",
    stroke: "#0E5CF4",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.293 34.647L9.76617 32.443L11.9701 29.9162",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4992 10.8259C31.3057 10.5569 30.9308 10.4957 30.6618 10.6892C30.3928 10.8827 30.3316 11.2577 30.5251 11.5267L31.4992 10.8259ZM32.9292 18.9998C32.9292 26.0755 27.1932 31.8116 20.1174 31.8116V33.0116C27.8559 33.0116 34.1292 26.7383 34.1292 18.9998H32.9292ZM30.5251 11.5267C32.0382 13.63 32.9292 16.21 32.9292 18.9998H34.1292C34.1292 15.9502 33.1543 13.1266 31.4992 10.8259L30.5251 11.5267ZM20.1174 31.8116H10.0586V33.0116H20.1174V31.8116Z",
    fill: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4141 3.35303L27.9409 5.557L25.7369 8.0838",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20783 27.1741C6.40134 27.4431 6.77628 27.5043 7.04528 27.3108C7.31428 27.1173 7.37547 26.7423 7.18196 26.4733L6.20783 27.1741ZM4.77785 19.0002C4.77785 11.9245 10.5139 6.18844 17.5896 6.18844L17.5896 4.98844C9.85113 4.98844 3.57785 11.2617 3.57785 19.0002L4.77785 19.0002ZM7.18196 26.4733C5.66887 24.37 4.77785 21.79 4.77785 19.0002L3.57785 19.0002C3.57785 22.0498 4.55277 24.8734 6.20783 27.1741L7.18196 26.4733ZM17.5896 6.18844L27.6484 6.18844L27.6484 4.98844L17.5896 4.98844L17.5896 6.18844Z",
    fill: "#20242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredWire);
export default __webpack_public_path__ + "static/media/ic-colored-wire.874e755d93b97fd96eb910464dd80b17.svg";
export { ForwardRef as ReactComponent };